/**
 * The product's spacing scale.
 *
 * Derived from what the codebase already does rather than invented: 1,096 spacing declarations were
 * measured across `src`, none of them interpolated — every gap, margin and padding was a number
 * typed at the point of use. 86% of them were already multiples of four, and five values did most
 * of the work.
 *
 *     24px  210 uses   ← the product's default gap
 *      8px  203
 *     16px  184
 *     12px   84
 *      4px   75
 *
 * These seven steps cover 85% of that. The rest — 40, 20, 10, 6, 5 and forty other one-offs — are
 * not tokens: when you touch one, move it to the nearest step rather than adding a step for it. A
 * scale that admits every value that has ever been used is a list, not a scale.
 *
 * Keyed by the number so there is nothing to learn and nothing to translate: a design review that
 * says "16 between them" and the code that does it say the same thing.
 *
 *     import {spacingStyles} from '../../utils/styles';
 *
 *     const Row = styled.div`
 *       gap: ${spacingStyles[8]};
 *       padding: ${spacingStyles[16]} ${spacingStyles[24]};
 *     `;
 *
 * ⚠ `0` is deliberately absent — it needs no token and reads better as `0`.
 */
export const spacingStyles = Object.freeze({
  4: '4px',
  8: '8px',
  12: '12px',
  16: '16px',
  24: '24px',
  32: '32px',
  48: '48px',
});

/** The steps in order, for anything that needs to walk the scale (the Foundations story does). */
export const spacingSteps = Object.freeze(Object.keys(spacingStyles).map(Number));
